import { IBreadcrumbsItemProps } from 'telia-front-react';
import { MouseEvent } from 'react';
import { computed } from 'mobx';
import { capitalizeFirstLetter } from '../util/TextUtil';
import RouteStore from './RouteStore';
import MenuStore from './MenuStore';
import RootStore from './RootStore';
import LanguageStore, { languageSlug } from './LanguageStore';
import ContentStore from './ContentStore';
import { toPathname } from '../util/PathUtil';

class BreadcrumbStore {
  private routeStore: RouteStore;
  private menuStore: MenuStore;
  private languageStore: LanguageStore;
  private contentStore: ContentStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.menuStore = rootStore.menuStore;
    this.languageStore = rootStore.languageStore;
    this.contentStore = rootStore.contentStore;
  }

  @computed
  get hidden() {
    return this.routeStore.currentPathIsHomepage;
  }

  @computed
  get breadcrumbs(): IBreadcrumbsItemProps[] {
    const pathWithoutLang = this.routeStore.pathWithoutLang();
    const langSlug = languageSlug(this.languageStore.currentLanguage);
    const menuPostsByPath = this.menuStore.menuPostsByPath;

    const rootBreadcrumb: IBreadcrumbsItemProps = {
      label: 'Diil',
      current: pathWithoutLang.length === 0,
      url: langSlug || '/',
      onClick: this.getOnClickHandler(langSlug || '/')
    };

    const childBreadcrumbs: IBreadcrumbsItemProps[] = pathWithoutLang.map((pathEl: string, idx: number) => {
      const pathnameWithoutLang = toPathname(pathWithoutLang.slice(0, idx + 1));
      const post = menuPostsByPath.get(langSlug + pathnameWithoutLang);
      const current = idx === pathWithoutLang.length - 1;

      const currentPageContent = this.contentStore.currentPageContent;
      const label = (post && post.label) || (current && currentPageContent && currentPageContent.title) || capitalizeFirstLetter(pathEl);
      const path = langSlug + pathnameWithoutLang;

      return {
        label,
        current,
        url: path,
        onClick: this.getOnClickHandler(path)
      };
    });

    return [rootBreadcrumb, ...childBreadcrumbs];
  }

  private getOnClickHandler = (url: string) => {
    return (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      this.routeStore.push(url);
    };
  };
}

export default BreadcrumbStore;
